import React from "react";
import Iframe from "react-iframe";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const SliderVideos = (videos) => {
  return (
    <Carousel responsive={responsive}>
      {videos &&
        videos.videos.map(({ contenido }) => (
          <div>
            {contenido.titulo}
            <Iframe url={contenido.url_icono_img} allowFullScreen={true} />
          </div>
        ))}
    </Carousel>
  );
};
export default SliderVideos;
